(function ($) {
	$.resizeHero = function (element, options) {
		// 1**************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			ResizeHero = (function ($c, o) {
				var defaults = {
					hero: '.hero',
					position: '.position',
					element: '.background'
				}; 

				var _o = {},
					_ww = 0, // Window Width
					_wh = 0, // Window Height

					v = null, // Vimeo Player
					$v = null, // Vimeo Element

					$h = null, // Hero
					$p = null, // Position
					$e = null // Element
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);

					$h = $(_o.hero, $c);
					$p = $(_o.position, $c);
					$e = $(_o.element, $c).first();
					_GetMeasurements();
					_PositionElement();
				},

				_GetMeasurements = function() {
					_ww = $(window).width();
					_wh = $(window).height();
				},

				_OnWindowResize = function() {
					_GetMeasurements();
					_PositionElement();
				},

					_PositionElement = function() {
						var el = $e.get(0),
							ar = el.naturalHeight / el.naturalWidth,
							xh = _ww * ar,
							yw = _wh * (1 / ar);

						$h.css({ 'width': _ww, 'height': _wh });

						if (xh >= _wh) {
							$p.css({ 'width': _ww, 'height': xh, 'transform': 'translateY(' +((_wh - xh) / 2)+ 'px)' });
						} else if (yw >= _ww) {
							$p.css({ 'width': yw, 'height': _wh, 'transform': 'translateX(' +((_ww - yw) / 2)+ 'px)' });
						} else {
							console.log('weird...', _ww, _wh);
						}
					},

				_BindEvents = function () {
					$(window).resize(_OnWindowResize);
				},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.resizeHero = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('resizeHero')) {
				var plugin = new $.resizeHero(this, options);
				$(this).data('resizeHero', plugin);
			}
		});
	};
})(jQuery);
